import * as React from 'react';
import classnames from 'classnames';
import { ICoreContext } from '@msdyn365-commerce/core';

interface IDiscountBadgeProps {
    context: ICoreContext;
    className?: string;
    badge: string | undefined;
    size: 'small' | 'large' | 'x-large';
}

const DiscountBadge = (props: IDiscountBadgeProps) => {
    const baseClassName = 'dlvry-discount-badge';

    if (!props.badge) {
        return null;
    }

    let baseImageUrl = props.context.request.apiSettings.baseImageUrl;

    if (baseImageUrl.endsWith('/')) {
        baseImageUrl = baseImageUrl.slice(0, -1);
    }

    return (
        <div className={classnames(baseClassName, props.className, props.size)}>
            <img src={baseImageUrl + props.badge} />
        </div>
    );
};

export default DiscountBadge;
